import React from 'react';
import { stats } from '../data/content';
export function SocialProof() {
  return <section aria-labelledby="social-proof-title" className="w-full border-y border-line bg-ink-raised" data-id="element-152" data-mp="3lsui7b54y9s6">
      <div className="mx-auto max-w-content px-5 py-9 sm:py-14 lg:py-16" data-id="element-153" data-mp="36vtsteaf2qwv">
        <h2 id="social-proof-title" className="font-display text-2xl text-cream sm:text-3xl" data-id="element-154" data-mp="36xy5akmdsy8r">
          La ciencia y el método no mienten
        </h2>

        <dl className="mt-6 grid grid-cols-2 gap-x-6 gap-y-6 sm:mt-9 sm:gap-x-8 sm:gap-y-9 lg:grid-cols-4" data-id="element-155" data-mp="3fwhv34flexh">
          {stats.map(stat => <div key={stat.value} className="border-l border-line pl-5" data-id="element-156" data-mp="8d6ccx6oggs6">
              <dt className="font-display text-3xl leading-none text-gold sm:text-[40px]" data-id="element-157" data-mp="3ptefceppldeb">
                {stat.value}
              </dt>
              <dd className="mt-3 text-[13px] leading-snug text-muted" data-id="element-158" data-mp="3urg33cy2y0w4">{stat.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}